export default class ProgressBar {
    constructor($filter, Events, Subscriber, Tag, Statistics, Campaign, Segment) {
        this._filter = $filter;
        this.eventHandler = Events;
        this.subscriberRepo = Subscriber;
        this.tagRepo = Tag;
        this.statisticRepo = Statistics;
        this.campaignRepo = Campaign;
        this.segmentRepo = Segment;

        this.getTexts();
    }

    getTexts() {
        this.texts = {
            segment: {
                Saving: this._filter('translate')('SEGMENT:SYNC:SAVING'),
                Fetching: this._filter('translate')('SEGMENT:SYNC:FETCHING'),
                Syncing: this._filter('translate')('SEGMENT:SYNC:SYNCING'),
                Finished: this._filter('translate')('SEGMENT:SYNC:FINISHED'),
                Cancelled: this._filter('translate')('SEGMENT:SYNC:CANCELLED')
            }
        };
    }

    getData(progressTypeName, itemId, dispatcherType = 'campaign') {

        if (progressTypeName == 'statistic-export' && itemId) {
            return this.statisticRepo.exportProgress(itemId, dispatcherType);
        } else if (progressTypeName == 'statistic-automation-export' && itemId) {
            return this.statisticRepo.exportProgress(itemId, 'automation');
        } else if (progressTypeName == 'segment-export') {
            return this.segmentRepo.exportProgress(itemId);
        } else if (progressTypeName == 'tag-export') {
            return this.tagRepo.getExportById(itemId);
        } else if (progressTypeName == 'subscriber-import') {
            return this.subscriberRepo.getImportProgress();
        } else if (progressTypeName == 'campaign-export') {
            return this.campaignRepo.exportProgress();
        }
    };

    getText(progressTypeName, state, data) {
        this.getTexts();
        if (progressTypeName == 'statistic-export' || progressTypeName == 'statistic-automation-export') {
            return null;
        }
    };

    isFinished(progressTypeName, progress) {
        if (progressTypeName == 'statistic-export' || progressTypeName == 'statistic-automation-export') {
            return (progress.url || progress.finished || progress.meta == null);
        } else if (progressTypeName == 'segment-export' || progressTypeName == 'tag-export') {
            return (progress.meta.state == 'Finished' || progress.url != null);
        } else if (progressTypeName == 'subscriber-import') {
            return (progress.state == 'Finished');
        } else if (progressTypeName == 'campaign-export') {
            return (progress.meta.state == 'Finished' || progress.url != null);
        }
    };
}